import { render } from "./Gate.vue?vue&type=template&id=6b315446&scoped=true"
import script from "./Gate.vue?vue&type=script&lang=js"
export * from "./Gate.vue?vue&type=script&lang=js"

import "./Gate.vue?vue&type=style&index=0&id=6b315446&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b315446"]])

export default __exports__